import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { useAuth } from "react-oidc-context";

function Avatar({ name }) {
	if (name === undefined) name = " "
  return (
    <Box
      sx={{
        display: "flex",
        height: "60px",
        width: "60px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          background: "blue",
          borderRadius: "25px",
          height: "50px",
          width: "50px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography sx={{}}>{name[0]}</Typography>
      </Box>
    </Box>
  );
}

const signOutRedirect = () => {
  const clientId = "41vjsqnlqsalec316ga7hdjn76";
  const logoutUri = window.location.origin;
  const cognitoDomain =
    "https://eu-north-1htt4uq7xc.auth.eu-north-1.amazoncognito.com";
  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};

function LoginButton({ auth }) {
  if (auth.isAuthenticated) {
    return (
      <Button
        onClick={() => {
          void auth.removeUser();
          signOutRedirect();
        }}
      >
        Sign out
      </Button>
    );
  }
  return (
    <Button
      variant="contained"
      onClick={() => {
        auth.signinRedirect();
      }}
    >
      Sign in
    </Button>
  );
}
const usersUrl = import.meta.env.VITE_API_BASE_URL + "/users"

function getUserData(token, setData) {
  fetch(usersUrl, {
    method: "GET",
    headers: { authorization: token },
  })
    .then((response) => response.json())
    .then((jsonData) => {
      if (!Array.isArray(jsonData)) return;
      for (let i = 0; i < jsonData.length; i++) {
        jsonData[i].id = i;
      }
      setData(jsonData);
    });
}

function getCurrentUsersName(email, userData) {
  for (var i = 0; i < userData.length; i++) {
    if (email === userData[i].email) {
      return userData[i].name;
    }
  }
  return "";
}
function Login() {
  const [userData, setUserData] = useState([]);

  var auth = useAuth();
  var name = "";
  useEffect(() => {
    getUserData(auth.user?.access_token, setUserData);
  }, [auth.user?.access_token]);
  var email = auth.user?.profile.email;
  name = getCurrentUsersName(email, userData);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Avatar name={name} />
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography>{name}</Typography>
          <Typography
            sx={{
              font: "roboto",
              fontSize: "10pt",
              color: "grey",
              textOverflow: "ellipsis",
              overflow: "hidden",
              width: "130px",
            }}
          >
            {email}
          </Typography>
        </Box>
      </Box>
      <LoginButton auth={auth} />
    </Box>
  );
}

export default Login;
